import Vue from "vue";
import axios from "axios";

const http = axios.create({
  baseURL: process.env.NODE_ENV === "production"
    ? "https://api.sigfrotagov.com.br"
    : "http://localhost:3010",
});

// Interceptor para injetar o token em cada requisição
http.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem("token") || localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      if (!sessionStorage.getItem("token")) {
        try {
          sessionStorage.setItem("token", token);
        } catch (e) {
          // Ignora erro de acesso a storage
        }
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Vue.use({
  install(Vue) {
    Vue.prototype.$http = http;
  },
});

export default http;
